import React, { useContext } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { clickOriginTypes, gEnums } from '../../enums/globalEnums';
import { dataManagementTypes, appDataActionTypes, appCollectionActionTypes } from '../../viewSettings/enums/itemActionTypes';
import FilterProvider from '../../cnr/contexts/FilterContext';
import UiDataFilters, { fullFilterTypes } from '../UiDataFilters';
import UiAppDataLinks from './dataManagement/UiAppDataLinks';

const AppDashboard = React.lazy(() => import('../../components/viewers/AppDashboard'));
const AppStorageTransferWithProvider = React.lazy(() => import('./dataModifications/AppStorageTransfer'));
const CreateNotificationWizard = React.lazy(() => import('../../appNotifications/CreateNotificationWizard'));
const CreateTopicWizard = React.lazy(() => import('../../appNotifications/CreateTopicWizard'));
const UiAmmendData = React.lazy(() => import('./dataManagement/UiAmmendData'));
const UiBackupData = React.lazy(() => import('./dataManagement/UiBackupData'));
const UiConvertToDocument = React.lazy(() => import('./dataManagement/UiConvertToDocument'));
const UiCopyPaste = React.lazy(() => import('./dataManagement/UiCopyPaste'));
const UiCreateGlobalData = React.lazy(() => import('./dataManagement/UiCreateGlobalData'));
const UiFixData = React.lazy(() => import('./dataManagement/UIFixData'));
const UiFixPropData = React.lazy(() => import('./dataManagement/UiFixPropData'));
const UiFixPropNames = React.lazy(() => import('./dataManagement/UiFixPropNames'));
const UiGoogleLinks = React.lazy(() => import('./dataManagement/UiGoogleLinks'));
const UiGoogleSheets = React.lazy(() => import('./dataManagement/UiGoogleSheets'));
const UiLinks = React.lazy(() => import('./dataManagement/UiLinks'));
const UiMoveData = React.lazy(() => import('./dataManagement/UiMoveData'));
const UiParentKeys = React.lazy(() => import('./dataManagement/UiParentKeys'));
const UiSecretData = React.lazy(() => import('./dataManagement/UiSecretData'));
const UiUpload = React.lazy(() => import('./dataManagement/UiUpload'));
const ImageMapping = React.lazy(() => import('../../components/swipe/ImageMapping'));

const AppDataContent = (props) => {

  const { handleItemClose } = props ?? {};

  const dataManagementContext = useContext(DataManagementContext);
  const { dataManagement_state } = dataManagementContext ?? {};
  const { dataManagementType, viewDataMode } = dataManagement_state ?? {};
  const _dataManagementType = viewDataMode ? viewDataMode : dataManagementType;

  switch (_dataManagementType) {

    case appDataActionTypes.ammendPropData:
    case appDataActionTypes.fixPropNames:
      return <UiFixPropNames _dataManagementType={_dataManagementType} />;

    case appDataActionTypes.backupItemData:
      return <UiBackupData />;

    case appDataActionTypes.createSingleDocument:
      return <UiConvertToDocument />;

    case appDataActionTypes.createAppDataLinks:
      return <UiAppDataLinks />;

    case appDataActionTypes.copyData:
      return <UiCopyPaste />;

    case appDataActionTypes.createFilter:
      return (
        <FilterProvider>
          <UiDataFilters fullFilterType={fullFilterTypes.create} />
        </FilterProvider>
      );

    case appDataActionTypes.createGlobalData:
    case appDataActionTypes.updateStaticViews:
      return <UiCreateGlobalData />;

    case appDataActionTypes.createNotification:
      return <CreateNotificationWizard handleClose={handleItemClose} notificationOriginType={gEnums.notificationOriginTypes.uiItem} />;

    case appDataActionTypes.moveData:
    case appDataActionTypes.moveDataTo:
      return <UiMoveData />;

    case appDataActionTypes.secretData:
      return <UiSecretData />;

    case appDataActionTypes.transferStorageFolder:
      return <AppStorageTransferWithProvider clickOriginType={clickOriginTypes.dataViewer} handleCancel={handleItemClose} />;

    case appDataActionTypes.updateParentKeys:
    case appDataActionTypes.convertToParentKeys:
      // case dataManagementTypes.convertToParentKeys:
      return <UiParentKeys />;

    case appDataActionTypes.manageData:
      return <AppDashboard />;

    case appDataActionTypes.fixData:
      return <UiFixData />;

    case appCollectionActionTypes.bulkImageUpload:
    // case dataManagementTypes.bulkImageUpload:

    case dataManagementTypes.storageImages:
      return <UiUpload origin={'UiDataManagement'} showUpload={true} />;

    case dataManagementTypes.fixPropData:
      return <UiFixPropData />;

    case dataManagementTypes.googleSheetLink:
      return <UiGoogleLinks />;

    case dataManagementTypes.googleDataUpdate:
    case dataManagementTypes.googleSheetUpdate:
      return <UiGoogleSheets />;

    case dataManagementTypes.imageLinks:
      return <UiLinks />;

    case dataManagementTypes.imageMapping:
      return <ImageMapping imageMapType={gEnums.imageMapTypes.itemLocation} handleCancel={handleItemClose} inDashboard={true} />;

    case dataManagementTypes.createTopic:
      return <CreateTopicWizard topicOriginType={gEnums.topicOriginTypes.page} activeTopic={{ name: 'test' }} />;

    case dataManagementTypes.updateDataRelationships:
    case dataManagementTypes.modifyList:
      return <UiAmmendData />;

    default:
      return <div>{'AppDataContent: No component for ' + dataManagementType}</div>;
  }
};

export default AppDataContent;
